import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { SETTINGS_ADMIN_LIST_QUERY } from '../../graphql';

@Injectable({ providedIn: 'root' })
export class SettingsAdminListService {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getSettingsAdminList(accountDnvId: string | null): Observable<any> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_ADMIN_LIST_QUERY) || 'adminList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_ADMIN_LIST_QUERY,
        variables: {
          accountDNVId: accountDnvId,
        },
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.adminList),
      );
  }
}
